import { as as asFunc } from "./as";
import { href as hrefFunc } from "./href";
import { ContentLinkContextData } from "./utils";

export const initializeContentLink = (contextData: ContentLinkContextData) => {
  return {
    href: hrefFunc(contextData),
    as: asFunc(contextData),
  };
};
